var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from "react";
import OrderBookSideBarPastInstallmentRows, { EPastInstallmentsStatus, } from "./OrderBookSideBarPastInstallmentRows";
import "@frameworks/shared-library/stylesheets/components/OrderBookSideBar/OrderBookSideBarPastInstallments.scss";
import GenericPopup from "@frameworks/shared-library/components/GenericPopup";
import GenericCheckbox from "@frameworks/shared-library/components/GenericCheckbox/GenericCheckbox";
import EdButton, { EdButtonIcon, } from "@frameworks/web/components/generic/edbutton/edButton";
import FilterLabels from "@frameworks/web/components/generic/FilterLabels/FilterLabels";
import GenericTimeline, { ETimelineState, } from "@frameworks/shared-library/components/GenericTimeline/GenericTimeline";
import moment from "moment";
var OrderBookSideBarPastInstallments = function (props) {
    var _a = __read(useState(false), 2), isShow = _a[0], setIsShow = _a[1];
    var filterByOptions = props.filterByOptions, allPastInstallments = props.allPastInstallments, filterBy = props.filterBy, setFilterBy = props.setFilterBy, pastInstallments = props.pastInstallments, setPastInstallments = props.setPastInstallments, initialItemsLengthPastInstallments = props.initialItemsLengthPastInstallments, footerText = props.footerText;
    var _b = __read(useState(null), 2), footerSection = _b[0], setFooterSection = _b[1];
    var _c = __read(useState([]), 2), appliedFilterValues = _c[0], setAppliedFilterValues = _c[1];
    var _d = __read(useState(false), 2), showTimelineForPastInstallments = _d[0], setShowTimelineForPastInstallments = _d[1];
    var _e = __read(useState(null), 2), selectedPastInstallmentItem = _e[0], setSelectedPastInstallmentItem = _e[1];
    var _f = __read(useState([]), 2), timelineDetailsForSelectedPastInstallment = _f[0], setTimelineDetailsForSelectedPastInstallment = _f[1];
    var checkFooterVisibility = function (items) {
        if (!(props === null || props === void 0 ? void 0 : props.isViewAllClicked) && items.length > 5) {
            setFooterSection(function () { return (React.createElement("footer", { className: "past-installments-footer txt-han-blue text-center w-100" },
                React.createElement("span", { onClick: handleViewAll, tabIndex: 0, className: "bg-transparent hand_cursor" },
                    React.createElement("span", { className: "text-decoration-underline DMSansNormal_12_400" }, footerText),
                    React.createElement("span", { className: "past-installments-footer-icon-container" },
                        React.createElement("i", { className: "edel-icon-arrow-right1" }))))); });
        }
        else {
            setFooterSection(null);
        }
    };
    var applyFilters = function (filteryStatus) {
        setAppliedFilterValues(filteryStatus);
        var showWithAllStatuses = filteryStatus.length > 1 || filteryStatus.length === 0;
        if (showWithAllStatuses) {
            var updatedInstallments = (props === null || props === void 0 ? void 0 : props.isViewAllClicked)
                ? allPastInstallments
                : allPastInstallments.slice(0, initialItemsLengthPastInstallments);
            setPastInstallments(updatedInstallments);
            if (!(props === null || props === void 0 ? void 0 : props.isViewAllClicked))
                checkFooterVisibility(allPastInstallments);
            return;
        }
        var filterByStatus = filteryStatus[0];
        var filteredInstallments = allPastInstallments.filter(function (item) { return item.status === filterByStatus; });
        if (props === null || props === void 0 ? void 0 : props.isViewAllClicked) {
            setPastInstallments(filteredInstallments);
        }
        else {
            setPastInstallments(filteredInstallments.slice(0, 5));
            checkFooterVisibility(filteredInstallments);
        }
    };
    var clearAll = function () {
        setAppliedFilterValues([]);
        if (filterBy.status.length === 0)
            return;
        setFilterBy(__assign(__assign({}, filterBy), { status: [] }));
        if (props === null || props === void 0 ? void 0 : props.isViewAllClicked) {
            setPastInstallments(function () { return allPastInstallments; });
            return;
        }
        setPastInstallments(function () {
            return allPastInstallments.slice(0, initialItemsLengthPastInstallments);
        });
        checkFooterVisibility(allPastInstallments);
    };
    var handleViewAll = function () {
        props === null || props === void 0 ? void 0 : props.setIsViewAllClicked(true);
        var selectedStatus = filterBy.status[0];
        var filteredInstallments = allPastInstallments.filter(function (item) { return item.status === selectedStatus; });
        if (filteredInstallments.length > 0) {
            setPastInstallments(filteredInstallments);
            setFooterSection(null);
        }
        else {
            setPastInstallments(allPastInstallments);
            setFooterSection(null);
        }
    };
    useEffect(function () {
        checkFooterVisibility(allPastInstallments);
    }, [allPastInstallments]);
    var handleOnClick = function () {
        if (props.filterBy.status.length > 0 && isShow) {
            setIsShow(function (prev) { return !prev; });
        }
    };
    var handleClearAll = function () {
        clearAll();
        setIsShow(false);
    };
    var handleCancel = function () {
        setIsShow(false);
    };
    var handleApply = function () {
        applyFilters(props.filterBy.status);
        setIsShow(false);
    };
    var handleOnChange = function (event) {
        var _a = __read([event.target.id, event.target.checked], 2), value = _a[0], checked = _a[1];
        if (checked) {
            props.setFilterBy(function (prev) { return (__assign(__assign({}, prev), { status: __spreadArray([], __read(new Set(__spreadArray(__spreadArray([], __read(prev.status), false), [value], false))), false) })); });
        }
        else {
            props.setFilterBy(function (prev) { return (__assign(__assign({}, prev), { status: prev.status.filter(function (item) { return item !== value; }) })); });
        }
    };
    var setShow = function () {
        setIsShow(true);
    };
    var generateCheckboxProps = function (value) {
        var _a, _b;
        var id = value;
        var isChecked = (_b = (_a = props === null || props === void 0 ? void 0 : props.filterBy) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.includes(id);
        return {
            onChange: handleOnChange,
            id: id,
            checked: isChecked !== null && isChecked !== void 0 ? isChecked : false,
            value: value,
        };
    };
    var generateLabelProps = function (value) {
        return {
            htmlFor: value,
            children: (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "DMsanL_12_300" }, value))),
        };
    };
    var removeFilter = function (filterStatus) {
        var updatedStatusFilter = props.filterBy.status.filter(function (item) { return item !== filterStatus; });
        props.setFilterBy(function (prev) { return (__assign(__assign({}, prev), { status: updatedStatusFilter })); });
        applyFilters(updatedStatusFilter);
    };
    var handleBackOnClick = function () {
        setShowTimelineForPastInstallments(false);
    };
    var generateDetailsForTimeline = function () {
        if (!selectedPastInstallmentItem)
            return;
        setTimelineDetailsForSelectedPastInstallment([
            {
                header: "Order created",
                status: ETimelineState.COMPLETED,
                description: moment(selectedPastInstallmentItem.dpOrderDate).format("D MMM YYYY, h:mm:ss A"),
            },
            {
                header: selectedPastInstallmentItem.status === EPastInstallmentsStatus.SUCCESS
                    ? "Order accepted"
                    : "Order rejected",
                status: selectedPastInstallmentItem.status === EPastInstallmentsStatus.FAILED
                    ? ETimelineState.FAILED
                    : ETimelineState.COMPLETED,
                description: moment(selectedPastInstallmentItem.dpOrderDate).format("D MMM YYYY, h:mm:ss A"),
            },
        ]);
    };
    useEffect(function () {
        if (showTimelineForPastInstallments && selectedPastInstallmentItem) {
            generateDetailsForTimeline();
        }
    }, [showTimelineForPastInstallments, selectedPastInstallmentItem]);
    return (React.createElement("div", { className: "primary-past-installments-container" }, showTimelineForPastInstallments ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "d-flex gap-2 align-items-center" },
            React.createElement("span", { onClick: handleBackOnClick, className: "hand_cursor" },
                React.createElement("i", { className: "edel-icon-left-arrow txt_ultramarine-blue2" })),
            React.createElement("header", { className: "past-installments-header d-flex justify-content-between align-items-center" },
                React.createElement("span", { className: "DMSan_13_500" },
                    "Order details for ",
                    selectedPastInstallmentItem.dpOrderDate))),
        React.createElement("div", { className: "mx-3 mt-20" },
            React.createElement("span", { className: "DMSansNormal_12_400 text-decoration-underline" }, "Order Timeline"),
            React.createElement(GenericTimeline, { timelineDetails: timelineDetailsForSelectedPastInstallment, parentClassName: "p-0" })))) : (React.createElement(React.Fragment, null,
        React.createElement("header", { className: "past-installments-header d-flex justify-content-between align-items-center" },
            React.createElement("h2", { className: "DMSan_13_500" }, "Past Installments"),
            React.createElement("span", { className: "past-installment-filter d-flex ".concat(Boolean(appliedFilterValues.length) ? "with-border" : "", " ").concat(isShow ? "highlight-input" : "") },
                Boolean(appliedFilterValues.length) ? (React.createElement("span", { className: "filter-lables DMsanR_08_400 d-flex align-items-center" }, appliedFilterValues === null || appliedFilterValues === void 0 ? void 0 : appliedFilterValues.map(function (filterItem, index) {
                    return (React.createElement(FilterLabels, { LabelText: filterItem, closeBtn: true, key: "".concat(filterItem, "-").concat(index), FilterAction: removeFilter }));
                }))) : null,
                React.createElement(GenericPopup, { placement: "bottom-end", isHeadline: true, isShow: isShow, setIsShow: setShow, removeTooltipArrow: true, containerDom: function () {
                        return document.getElementById("pastInstallments-filter-btn");
                    }, buttonOnClick: handleOnClick, button: React.createElement("div", { className: "position-relative filter-icon-container" },
                        React.createElement(EdButtonIcon, { id: "pastInstallments-filter-btn", btnIcon: "edel-icon-filter-1", btnTyp: "link", className: "custom-filter ".concat(isShow ? "open__filter" : ""), slim: true, paths: 3 }),
                        Boolean(appliedFilterValues.length) && (React.createElement("span", { className: "filter-selected d-flex" }))), children: React.createElement("div", { className: "offerings-filters-sort-tabs-primary-container" },
                        React.createElement("div", { className: "filter-header d-flex justify-content-between align-items-center" },
                            React.createElement("div", { className: "DMSanN_15_400" }, "Filters"),
                            React.createElement("div", { className: "filter-sort-clear-btn-wrapper" },
                                React.createElement(EdButton, { btnTyp: "text-only", className: "txt-han-blue DMSanN_14_400", value: "Clear All", onClick: handleClearAll }))),
                        React.createElement("div", null, filterByOptions === null || filterByOptions === void 0 ? void 0 : filterByOptions.map(function (item) {
                            var labelProps = generateLabelProps(item.name);
                            var checkboxProps = generateCheckboxProps(item.name);
                            return (React.createElement(GenericCheckbox, { parentClassName: "individual-checkbox-wrapper", checkboxProps: __assign(__assign({}, checkboxProps), { className: filterBy.status.includes(item.name)
                                        ? "han-blue"
                                        : "txt-whispering-periwinkle" }), labelProps: __assign(__assign({}, labelProps), { className: filterBy.status.includes(item.name)
                                        ? "han-blue"
                                        : "txt-whispering-periwinkle" }), key: item.id }));
                        })),
                        React.createElement("div", { className: "d-flex align-items-center gap-2 justify-content-between offerings-filters-action-buttons-footer bg_white" },
                            React.createElement(EdButton, { btnTyp: "text-only", value: "Cancel", onClick: handleCancel, className: "offerings-custom-button DMSan_14_500 txt-han-blue w-100" }),
                            React.createElement(EdButton, { btnTyp: "tomato", value: "Apply", onClick: handleApply, className: "offerings-custom-button DMSan_14_500 px-40" }))) }))),
        React.createElement("main", { className: "past-installments-content d-flex w-100 flex-column justify-content-start" }, pastInstallments === null || pastInstallments === void 0 ? void 0 : pastInstallments.map(function (installment, index) { return (React.createElement(OrderBookSideBarPastInstallmentRows, { key: "".concat(installment.orderNumber, "-").concat(index), pastInstallmentItem: installment, setShowTimelineForPastInstallments: setShowTimelineForPastInstallments, setSelectedPastInstallmentItem: setSelectedPastInstallmentItem })); })),
        footerSection ? footerSection : null))));
};
export default OrderBookSideBarPastInstallments;
